"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const usePostMessage_1 = require("./usePostMessage");
function useOpenExternalUrl(url) {
    const postOpenUrl = (0, usePostMessage_1.default)('openUrl');
    const openUrl = (0, react_1.useCallback)(() => {
        postOpenUrl(url);
    }, [url]);
    return openUrl;
}
exports.default = useOpenExternalUrl;
